const schematKonkurs = {
    type: "object",
    "required": ["login",'haslo'],
    properties: {
        "login":{
            type: "string",
            title: "Podaj mail",
            format: 'email'
        },
        "haslo": {
            type: "string",
            title: "Kod Konkursu",
        },
        "idKonkurs" :{
            type: "number"
        }
    },
}

const uiSchemat = {
    "ui:submitButtonOptions":{    
        "submitText": "Autoryzacja",
        "norender": false,
        "props": {
            "disabled" : false,
            "className": "btn btn-danger"
        }
    },
        "ui:buttonButtonOptions":{    
        "submitText": "Rezygnacja",
        "norender": false,
        "props": {
            "disabled" : false,
            "className": "btn btn-danger"
        }
    },
    "login":{
        "ui:option" :{ inputType: 'email'},
        "ui:placeholder": "Podaj adres pocztowy"
    },
    "idKonkurs":{
        "ui:widget" :"hidden",
        "ui:placeholder": "ID Konkursu"
    },
    "haslo":{
        "ui:widget":"text",
        "ui:placeholder":"Podaj Kod Konkursu"
    },
}
const  formData = {}
export {schematKonkurs,formData,uiSchemat,}